export default __webpack_public_path__ + "static/media/CompanionAppsIcon.68d96896.svg";